import * as _ from 'lodash'
import { JobT, VariableExpenseT } from "../../../types/Job"



export const OptionsPermissions = {
    'contact': 'Contact',
    'documents': 'Documents',
    'sales': 'Sales',
    'payment': 'Payment',
    'address': 'Address',
}

export const OptionsJobType = {
    moving_labor: "Moving Labor",
    intrastate_local: "Intrastate Local Moving",
    intrastate_long: "Intrastate Long-distance Moving",
    interstate: "Interstate Moving",
    international: "International Moving",
    junk_removal: "Junk Removal",
}

export const OptionsJobStatus = {
    inquiring: 'Inquiring',
    scheduled: 'Scheduled',
    completed: 'Completed',
    canceled: 'Canceled',
    spam: 'Spam',
    missed: 'Missed',
    refused_price: 'Refused Price'
}

export const OptionsJobSource = {
    craigslist: 'Craigslist',
    mailer: 'Mailer',
    sem: 'Search Engine Marketing',
    referral: 'Referral',
    yelp: 'Yelp',
    facebook: 'Facebook',
    other: 'Other'
}



export const OptionsActivityType = {
    'load': 'Load',
    'unload': 'Unload',
    'pack': 'Pack',
    'estimate': 'Estimate',
    'labor' : 'Labor'
}


export const OptionsLocationType = {
    'Apartment': 'Apartment',
    'Condo': 'Condo',
    'House': 'House',
    'Office': 'Office',
    'Storage': 'Storage',
    'Storefront': 'Storefront',
    'Townhome': 'Townhome',
    'Warehouse': 'Warehouse',
}



export const OptionsItemsExpense: { [k: string]: VariableExpenseT } = {

    'food': {
        "value": 0,
        "rateLabel": "Cost, $",
        "unitsLabel": "",
        "verboseName": "Food"
    },
    'fuelReimbursementFlat': {
        "value": 0,
        "rateLabel": "Cost, $",
        "unitsLabel": "",
        "verboseName": "Fuel Reimbursement, Flat"
    },
    'fuelReimbursementVariable': {
        "value": 0,
        "rateLabel": "Rate, $/mile",
        "unitsLabel": "miles",
        "verboseName": "Fuel Reimbursement, Variable"
    },
    'mechanicalFailure': {
        "value": 0,
        "rateLabel": "Amount",
        "unitsLabel": "$",
        "verboseName": "Mechanical Failure"
    },
    // 'mileage': {
    //     "value": 0,
    //     "rateLabel": "$/mile",
    //     "unitsLabel": "miles",
    //     "verboseName": "Mileage"
    // },
    'processingFee': {
        "value": 0,
        "rateLabel": "Cost, $",
        "unitsLabel": "",
        "verboseName": "Processing Fee"
    },
    'salesCommission': {
        "value": 0,
        "rateLabel": "Cost, $",
        "unitsLabel": "",
        "verboseName": "Sales Commission"
    },
    'shrinkWrap': {
        "value": 0,
        "rateLabel": "$/roll",
        "unitsLabel": "Rolls",
        "verboseName": "Shrink Wrap"
    },
    'depreciation': {
        "value": 0,
        "rateLabel": "Cost, $",
        "unitsLabel": "",
        "verboseName": "Depreciation"
    },


}


export const OptionsItemsCogs: { [k: string]: VariableExpenseT } = {
    'laborVariable': {
        "value": 0,
        "rateLabel": "$/hour",
        "unitsLabel": "hours",
        "verboseName": "Labor, Variable"
        // "verboseName": "Moving Labor, Variable <workerName>",
    },
    'laborFlat': {
        "value": 0,
        "rateLabel": "$",
        "unitsLabel": "Amount",
        "verboseName": "Labor, Flat"
    },
    'packingLabor': {
        "value": 0,
        "rateLabel": "$/hour",
        "unitsLabel": "hours",
        "verboseName": "Packing Labor"
    },
    'truck_rental': {
        "value": 0,
        "rateLabel": "$",
        "unitsLabel": "",
        "verboseName": "Truck Rental"
    },
    'truck_insurance': {
        "value": 0,
        "rateLabel": "$",
        "unitsLabel": "",
        "verboseName": "Truck Insurance"
    },
    'fuel': {
        "value": 0,
        "rateLabel": "$",
        "unitsLabel": "",
        "verboseName": "Fuel"
    },
    'boxes': {
        "value": 0,
        "rateLabel": "$/hour",
        "unitsLabel": "hours",
        "verboseName": "Boxes"
    },
    'depreciation': {
        "value": 0,
        "rateLabel": "$/hour",
        "unitsLabel": "hours",
        "verboseName": "Depreciation"
    },
    'food': {
        "value": 0,
        "rateLabel": "$/hour",
        "unitsLabel": "hours",
        "verboseName": "Food"
    },
    'freight_broker_commission': {
        "value": 0,
        "rateLabel": "$/hour",
        "unitsLabel": "hours",
        "verboseName": "Freight Broker Commission"
    },
    'hotel': {
        "value": 0,
        "rateLabel": "$/hour",
        "unitsLabel": "hours",
        "verboseName": "Hotel"
    },
    'packing_material': {
        "value": 0,
        "rateLabel": "$/hour",
        "unitsLabel": "hours",
        "verboseName": "Packing Material"
    },
    'processingFee': {
        "value": 0,
        "rateLabel": "$",
        "unitsLabel": "",
        "verboseName": "Processing Fee"
    },
    'per_diem': {
        "value": 0,
        "rateLabel": "$/hour",
        "unitsLabel": "hours",
        "verboseName": "Per Diem"
    },
    'repairs': {
        "value": 0,
        "rateLabel": "$/hour",
        "unitsLabel": "hours",
        "verboseName": "Repairs"
    },
    'tape': {
        "value": 0,
        "rateLabel": "$/hour",
        "unitsLabel": "hours",
        "verboseName": "Tape"
    },
    'vehicle_transport_fee': {
        "value": 0,
        "rateLabel": "$/hour",
        "unitsLabel": "hours",
        "verboseName": "Vehicle Transport Fee"
    },
    'other': {
        "value": 0,
        "rateLabel": "$/hour",
        "unitsLabel": "hours",
        "verboseName": "Other"
    },

}

/**
 * Generates dynamic "Damages - <Worker Name>" options for each crew member.
 * Key format: damages<workerId><crewIndex>
 * Anonymous workers (id=0) use: damages<0><crewIndex>
 */
export const generateDamagesOptionsForCrew = (job: JobT): { [k: string]: VariableExpenseT } => {
    const options: { [k: string]: VariableExpenseT } = {}
    if (!job?.crew || !Array.isArray(job.crew)) return options

    job.crew.forEach((crew, indexCrew) => {
        const fullName = `${crew.firstName ?? ''} ${crew.lastName ?? ''}`.trim()
        const displayName = fullName !== '' ? _.startCase(_.camelCase(fullName)) : `Worker ${indexCrew + 1}`
        const key = `damages<${crew.id}><${indexCrew}>`
        options[key] = {
            value: 0,
            rateLabel: "Amount, $",
            unitsLabel: "",
            verboseName: `Damages - ${displayName}`,
        }
    })

    return options
}

/** Returns true if the item key represents a worker damage entry */
export const isDamageItem = (item: string): boolean => /^damages<.+><\d+>$/.test(item)

/** Extracts workerId from a damage item key like "damages<42><0>" */
export const parseDamageItem = (item: string): { workerId: number } | null => {
    const match = item.match(/^damages<(\d+)><\d+>$/)
    if (!match) return null
    return { workerId: parseInt(match[1], 10) }
}
